mobileSize = 1100;

function placeTixBtn() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('.ticket').appendTo('.header-bottom')
  } else {
    $('.ticket').insertAfter('.directions');
  }
}


function countDown() {
  if ($('body').hasClass('saffireMobileSize')) {
      $('#siteInfoBannerWidget').insertAfter('.header-top');
  } else {
      $('#siteInfoBannerWidget').insertAfter('.header-logo');
  }
}

$(document).ready(function(){
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1100) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1101) {
    $('body').removeClass('saffireMobileSize');
  }
  
  // General Message
  $('.generalmessage').prependTo('header');

  // Replace Saffire Logo
	$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);

  // Place Tix Button
  placeTixBtn();

  // Email Signup
  $('.homepage .emailSubmitButton')
    .text('Subscribe')
    .appendTo('.emailInputField');

  // Fair Swiper Placement
  setTimeout(function(){
    if ($('body').hasClass('fair-theme')) {
      $('#fairSwiper')
        .insertAfter('#fairButtons')
        .css('opacity', '1');
    }
  },500)

  countDown();
  
});

$(window).load(function(){
	$('body').addClass('pageIsLoaded');
});

$(window).resize(function(){
  // Place Tix Button
  placeTixBtn();
  countDown();
});